export default __webpack_public_path__ + "_/images/bonuses/bonuses-card/empty-bonus-coin-26b667a5c8382bfe42eb4a85dd925e3b82576764be51f1e994b8493bc81924d5.png";